var map = {
	"./content/auto-article": 7491,
	"./content/auto-article.js": 7491,
	"./content/auto-default": 4120,
	"./content/auto-default.js": 4120,
	"./content/auto-genericcontent": 7135,
	"./content/auto-genericcontent.js": 7135,
	"./content/auto-leisuremangatranslation": 9893,
	"./content/auto-leisuremangatranslation.js": 9893,
	"./content/auto-memo": 6507,
	"./content/auto-memo.js": 6507,
	"./content/auto-memolist": 4979,
	"./content/auto-memolist.js": 4979,
	"./content/auto-missing": 6269,
	"./content/auto-missing.js": 6269,
	"./content/auto-workspace": 1332,
	"./content/auto-workspace.js": 1332,
	"./widgets/auto-default": 3660,
	"./widgets/auto-default.js": 3660,
	"./widgets/auto-widgetcontentcollection": 5068,
	"./widgets/auto-widgetcontentcollection.js": 5068,
	"./widgets/auto-widgetcontentview": 1789,
	"./widgets/auto-widgetcontentview.js": 1789,
	"./widgets/auto-widgetlogin": 3752,
	"./widgets/auto-widgetlogin.js": 3752,
	"./widgets/auto-widgetsimpletext": 3832,
	"./widgets/auto-widgetsimpletext.js": 3832
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6370;